export { TeamAvatar } from './TeamAvatar';
